import { toHalfWidth } from '@/utils'
import Vue from 'vue'

Vue.directive('replaceHalfWidth', {
  inserted: (el) => {
    const input = el.querySelector('input.el-input__inner')
    const handler = (ev) => {
      ev.target.value = toHalfWidth(ev.target.value)
      ev.target.dispatchEvent(new Event('input', { bubbles: true }))
    }
    input.addEventListener('blur', handler)
  },
})
